import IconBase, { IconBaseProps } from "./IconBase";

const GroupIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <g transform="rotate(-90 10 10)" fill="none" fillRule="evenodd">
      <rect
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        x="3"
        y="3"
        width="14"
        height="14"
        rx="2"
      />
      <rect
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        x="6"
        y="6"
        width="5"
        height="5"
        rx="2.5"
      />
      <path
        d="M14 9v3a2 2 0 0 1-2 2H9h0"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </IconBase>
);

export default GroupIcon;
